var collectZones = {}
var selected_zone = null;
var actualTicket = 0;
//var boxoffice = 0; 
var i = 0;

function updateTotalAmounts(data) {
    $('#subtotal').text(parseFloat(data.subtotal).toFixed(2));
    $('#taxes').text(parseFloat(data.taxes).toFixed(2));
    $('.total').text(parseFloat(data.total).toFixed(2));

    if ($('#donation_total').length) {
        $('#donation_total').text(parseFloat(data.donation).toFixed(2));
    }

    if ($('#next').length) {
        data.total > 0 ? $('#next').show() : $('#next').hide();
    }
}

function toggleLoader() {
    $('.loader').toggleClass('hidden');
    $('.zoom-control').toggleClass('hidden');
    $('.overflow-control').toggleClass('hidden');
}

function calculatePrice() {
    toggleLoader();

    var token = $('meta[name="csrf-token"]').attr('content');
    var seats = getSeatIds();

    $.ajax({
        url: '/api/calculatePrice',
        type: 'GET',
        data: {
            _token: token,
            seats: seats,
            boxoffice: boxoffice,
            donation: $('#donation_field').val(),
        },
        dataType: 'JSON',
    }).done(function (data) {
        updateTicketsPrice(data.tickets);
        updateTotalAmounts(data);
        toggleLoader();
    });
}

function mapZones() {
    console.log('hola');
    $.each(zones, function (index, value) {
        $('#mapzone' + value).click(function (e) {
            e.preventDefault();
            $.get('/api/change_map_zone/' + value).done(function (data) {
                return changeMapZone(value);
            });
        });
    });
}

function changeMapZone(value) {
    $('#map').hide();
    $('#maplink').show();
    if(!collectZones[value]){
        toggleLoader();
        $.get('/api/drawzone/'+showtime_id+ '/' + value).done(function (data) {
            $('#mapZone'+value+' .last-class:last-child').after(data.map);
            collectZones[value] = data.mapadat;
            adjustZoomBasedOnMaxItems(value);
            
            toggleLoader();
        });
    }
    $('#zone' + value).show();
    selected_zone = value;
    return false;
}

function adjustZoomBasedOnMaxItems(zoomable_id) {
    let maxItems = 0;

    // Buscar el <ul> con más <li>
    $("ul.seat-list").each(function () {
        let count = $(this).find("li").length; // Contar los <li> dentro del ul
        
        if (count > maxItems) {
            maxItems = count; // Guardar el mayor número encontrado
        }
    });

    if (maxItems === 0) return; // Si no hay <li>, salir

    // Definir escalas base
    const minScale = 0.5; // Zoom mínimo
    const maxScale = 1;   // Zoom máximo
    const baseItems = 24; // Número base de referencia
    
    // Calcular la nueva escala basada en el máximo número de <li>
    currentScale = Math.min(maxScale, Math.max(minScale, baseItems / maxItems));
    console.log('currentScale', currentScale);
    

    // Aplicar la escala al contenedor zoomable
    $(".zoomable").css("transform", `scale(${currentScale})`);
    updateScale(zoomable_id);
}

function updateScale(zoomable_id = null) {

    const $zoomable = $("#zoomable-"+zoomable_id);
    const $parent = $zoomable.parent(); // Contenedor padre

    // Aplicar la transformación de escala
    $zoomable.css("transform", `scale(${currentScale})`);

    // Ajustar el tamaño del contenedor padre al tamaño del contenido
    const rect = $zoomable[0].getBoundingClientRect();
    const scaledHeight = rect.height;        

    // Aplicar altura manual al contenedor padre
    $parent.css({
        "overflow-y": "hidden",
        "white-space": "nowrap",
        "height": `${scaledHeight + 150}px`
    });

}

function back() {
    $('#stage, #next').show();
    $('#back, #pay').hide();
    showMap();
}

function hideMap() {
    $('#stage, #next').hide();
    $('#back, #pay').show();

    location.hash = '#user-data';
}

function pay() {
    location.hash = '#user-data';
    $('#booking-form button[type="submit"]').click();
}

function addTicketToList(ticketId, fare_id = null) {    
    console.log('addTicketToList', ticketId, fare_id);
    
    actualTicket++;
    var discount = getDiscount();

    $('<input>').attr({
        type: 'hidden',
        'data-ticket-id': ticketId,
        'data-ticket-number': actualTicket,
        class: 'selectedSeats',
        name: 'seats[' + actualTicket + '][seat]',
        value: ticketId,
    }).appendTo('form');

    $('<input>').attr({
        type: 'hidden',
        'data-ticket-id': ticketId,
        'data-ticket-number': actualTicket,
        class: 'selectedSeats',
        name: 'seats[' + actualTicket + '][discount]',
        value: discount.value,
    }).appendTo('form');

    $('<input>').attr({
        type: 'hidden',
        'data-ticket-id': ticketId,
        'data-ticket-number': actualTicket,
        class: 'selectedSeats',
        name: 'seats[' + actualTicket + '][fare]',
        value: fare_id,
    }).appendTo('form');

    // If bootstrap tooltip is active the title disappear
    // so need to take the title from the data attribute
    var name = ''
    
    if ($('[data-id="' + ticketId + '_' + fare_id + '"]').length > 0) {
        // Aquí entran las no numeradas

        var name = $('[data-id="' + ticketId + '_' + fare_id + '"]').attr('title')
        ? $('[data-id="' + ticketId + '_' + fare_id + '"]').attr('title')
        : $('[data-id="' + ticketId + '_' + fare_id + '"]').data('original-title');
    } else {
        // Aquí entran las numeradas
        
        var name = $('[data-id="' + ticketId + '"]').attr('title')
        ? $('[data-id="' + ticketId + '"]').attr('title')
        : $('[data-id="' + ticketId + '"]').data('original-title');
    }
    
    
    if (discount.text) {
        name += ' (' + discount.text + ')';
    }

    var $icon = $('<i></i>')
        .attr('class', 'fa fa-remove')
        .attr('style', 'color: red');

    var $ticketName = $('<span></span>')
        .html(' ' + name)
        .prepend($icon);

    var $ticketPrice = $('<span></span>')
        .attr('class', 'pull-right ticket-price');

    var $div = $('<div></div>')
        .attr('data-ticket-id', ticketId)
        .attr('data-ticket-number', actualTicket)
        .attr('title', 'Eliminar entrada')
        .prepend($ticketName)
        .prepend($ticketPrice)
        .appendTo($('#resume-seats'));
    i++;
    addNumdocName(ticketId, actualTicket, name)
    return $div;
}
var array_hiddenInputs=[]
function addNumdocName(ticketId, actualTicket, name) {
    $("#tab_paxs").show();
    var html = "" +
        "<div class='last-class' id='addr" + ticketId + "' data-ticket-number='" + actualTicket + "'>" +
        "<div class='col-xs-12'>" +
        "<p><span class='text-primary'>LOCALIDAD: </span><b>" + name + "</b></p>" +
        "</div>" +
        "<div class='col-xs-12 col-sm-12 col-md-12 col-lg-3 form-group'><input name='seats[" + actualTicket + "][name]' type='text' placeholder='Nombre' class='form-control input-md'  /></div>" +
        "<div class='col-xs-12 col-sm-4 col-md-5 col-lg-4 form-group'>" +
        "<input name='seats[" + actualTicket + "][phone]' type='tel' id='phone" + actualTicket + "' type='text' placeholder='Teléfono' oninput='this.value = this.value.replace(/[^0-9.]/g, ``).replace(/(\\..*)\\./g, `$1`);' class='form-control input-md'>" +
        "</div>" +
        "<div class='col-xs-4 col-sm-4 col-md-2 col-lg-2 form-group'>" +
        "<select class='form-control input-md' onchange='selectTipoDoc(this, " + actualTicket + ")'" + " name='seats[" + actualTicket + "][tipo_doc]'>" +
        "<option value='1'>DNI-NIE</option>" +
        "<option value='3'>ID Card-Passport</option>" +
        "<option value='4'>Libro de Familia</option>" +
        "</select>" +
        "</div>" +
        "<div class='col-xs-8 col-sm-4 col-md-5 col-lg-3 form-group'>" +
        "<input name='seats[" + actualTicket + "][numdoc]' type='text' placeholder='Nº Documento'  class='form-control input-md'>" +
        "</div>" +
        "<div class='col-xs-8 col-sm-4 col-md-5 col-lg-3 form-group'>" +
        "<input type='text' style='display:none;' name='seats[" + actualTicket + "][birthday]' placeholder='Fecha de Nacimiento' id='date" + actualTicket +"' class='form-control datepicker_recurring_start' autocomplete='nope'>" +
        "</div>" +
        "<div class='col-xs-12 clearfix'><hr style='margin: 20px 0 15px;border: 1px solid #eee;'></div>" +
        "</div>";
    $('#tab_paxs .last-class:last-child').after(html);
    if (document.getElementById("tab_paxs") !== null) {
        array_hiddenInputs[actualTicket] = window.intlTelInput(document.querySelector('#phone' + actualTicket), {
            initialCountry: "es",
            separateDialCode: true,
            hiddenInput: "full_phone",
            utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.min.js"
        });
    }
}

function selectTipoDoc(sel, actualTicket)
{
    if(sel.value==4)
        $("#date"+actualTicket).show();
    else
        $("#date"+actualTicket).hide();
}

function getDiscount() {
    var discount = {value: null, text: ''};
    if (boxoffice){
        discount.value = parseFloat($('#discount-selected option:selected').val());
        discount.text = $('#discount-selected option:selected').text();
    }
    return discount;
}

function updateTicketsPrice(tickets) {
    for (var i in tickets) {
        $('div[data-ticket-number=' + tickets[i].number + '] .ticket-price')
            .text(parseFloat(tickets[i].price).toFixed(2) + ' €');
    }
}

function getSeatIds() {
    return $('.selectedSeats').serialize();
}

function addDonation() {
    var regex = /^\d+(\.\d{2})?$/;
    var donation = $('#donation_amount').val();

    if (!regex.test(donation)) {
        alert($('#donation_amount').data('error-regex-message'));

        return false;
    }

    if (donation <= 0) {
        alert($('#donation_amount').data('error-amount-message'));

        return false;
    }

    if ($('#donation_field').length) {
        $('#donation_ticket').remove();
        $('#donation_field').remove();
    }

    $('<input>').attr({
        type: 'hidden',
        name: 'donation',
        id: 'donation_field',
        value: donation,
    }).appendTo('form');

    var $icon = $('<i></i>')
        .attr('class', 'fa fa-remove')
        .attr('style', 'color: red');

    var $ticketName = $('<span></span>')
        .html(' Donación')
        .prepend($icon);

    var $ticketPrice = $('<span></span>')
        .attr('class', 'pull-right donation_price')
        .text(parseFloat(donation).toFixed(2) + ' €');

    $('<div></div>')
        .attr('id', 'donation_ticket')
        .attr('title', 'Eliminar donación')
        .prepend($ticketName)
        .prepend($ticketPrice)
        .appendTo($('#resume-seats'))
        .attr('onclick', 'removeDonation()');

    calculatePrice();
}

function addDonationModal() {
    var regex = /^\d+(\.\d{2})?$/;
    var donation = $('#donation_amount_modal').val();

    if (!regex.test(donation)) {
        alert($('#donation_amount').data('error-regex-message'));

        return false;
    }

    if (donation <= 0) {
        alert($('#donation_amount_modal').data('error-amount-message'));

        return false;
    }

    if ($('#donation_field').length) {
        $('#donation_ticket').remove();
        $('#donation_field').remove();
    }

    $('<input>').attr({
        type: 'hidden',
        name: 'donation',
        id: 'donation_field',
        value: donation,
    }).appendTo('form');

    var $icon = $('<i></i>')
        .attr('class', 'fa fa-remove')
        .attr('style', 'color: red');

    var $ticketName = $('<span></span>')
        .html(' Donación')
        .prepend($icon);

    var $ticketPrice = $('<span></span>')
        .attr('class', 'pull-right donation_price')
        .text(parseFloat(donation).toFixed(2) + ' €');

    $('<div></div>')
        .attr('id', 'donation_ticket')
        .attr('title', 'Eliminar donación')
        .prepend($ticketName)
        .prepend($ticketPrice)
        .appendTo($('#resume-seats'))
        .attr('onclick', 'removeDonation()');

    calculatePrice();
    formSubmit();
}

function formSubmit() {
    document.getElementById("booking-form").submit();
}

function removeDonation() {
    $('#donation_ticket').remove();
    $('#donation_field').remove();
    $('#donation_amount').val(0);

    calculatePrice();
}

document.addEventListener("DOMContentLoaded", function () {
    var element = document.getElementById("booking-form");
    if (element) {
        element.addEventListener('submit', goSubmit);
    }
});

var isShowedModal = false;
function goSubmit(evento) {
    for(var key in array_hiddenInputs){
        document.getElementsByName("seats["+key+"][full_phone]")[0].value = array_hiddenInputs[key].getNumber();
        document.getElementsByName('phone')[0].value = phone;
    }
    new Promise(function (resolve, reject) {
        resolve(validation());
    }).then(function (canSubmit) {
        if (canSubmit === false){
            evento.preventDefault();
        } else{
            if (!canSubmit.length) {
                var modals = document.getElementsByName('myModalDonation');
                if (!$('#donation_field').length && modals.length && !isShowedModal) {
                    evento.preventDefault();
                    $('#myModalDonation').modal('show');
                    isShowedModal = true;
                    return;
                }
                this.submit();
            } else{
                evento.preventDefault();
            }
        }
    });
}

